module.exports = __webpack_public_path__ + "static/media/synopsEnd.a5d5ebaa.mp3";